// extracted by mini-css-extract-plugin
export default {"page":"style_page__WD1Kx","table":"style_table__-bZZO","iconContainer":"style_iconContainer__RY+u1","icon":"style_icon__Kfwhp","name":"style_name__-Hmzr"};